import {Component, Input, AfterViewInit} from '@angular/core';
import {DeviceParamGatewayV3} from "../../../../../shared/classes/device/type-gateway-v3/device-param-gateway-v3";

@Component({
    selector: 'app-gateway-v3',
    templateUrl: './gateway-v3.component.html',
    styleUrls: ['./gateway-v3.component.css']
})
export class GatewayV3Component implements AfterViewInit {

    @Input('deviceParamGatewayV3') deviceParamGatewayV3: DeviceParamGatewayV3;
    @Input('editable') editable: boolean = true;

    constructor() {
    }

    ngAfterViewInit() {
        this.deviceParamGatewayV3 = this.deviceParamGatewayV3 === undefined ?  new DeviceParamGatewayV3() :  this.deviceParamGatewayV3;
    }

}
